import React from 'react';
import { motion } from 'framer-motion';
export const WhatsAppButton: React.FC = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/50256284598', '_blank');
  };
  return <motion.button initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} onClick={handleWhatsAppClick} className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white rounded-full p-3 shadow-lg focus:outline-none" aria-label="Contactar por WhatsApp" data-id="element-174">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-175">
        <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" data-id="element-176" />
        <path d="M9 10a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2Z" data-id="element-177" />
        <path d="M14 10a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0v-2Z" data-id="element-178" />
        <path d="M9.44 13.44a.5.5 0 0 1 .7-.7l3.5 3.5a.5.5 0 0 1-.7.7l-3.5-3.5Z" data-id="element-179" />
      </svg>
    </motion.button>;
};